"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskWatcherController = void 0;
const react_1 = __importStar(require("react"));
const TaskWatcherContext_1 = __importDefault(require("../useTaskWatcher/TaskWatcherContext"));
const TaskWatcherActionsContext_1 = __importDefault(require("../useTaskWatcherActions/TaskWatcherActionsContext"));
function TaskWatcherController({ children }) {
    const [ctxChanged, setCtxChanged] = (0, react_1.useState)();
    const watchedTasks = (0, react_1.useRef)([]);
    const watchTasks = (0, react_1.useCallback)((value) => {
        watchedTasks.current = [
            ...watchedTasks.current.filter(t => !value.find(v => v.id === t.id)),
            ...value,
        ];
        setCtxChanged(new Date());
    }, []);
    const stopWatchingTasks = (0, react_1.useCallback)((value) => {
        watchedTasks.current = [
            ...watchedTasks.current.filter(t => !value.find(v => v.id === t.id)),
        ];
        setCtxChanged(new Date());
    }, []);
    const actionsCtx = (0, react_1.useMemo)(() => ({
        watchTasks,
        stopWatchingTasks,
    }), [watchTasks, stopWatchingTasks]);
    const ctx = (0, react_1.useMemo)(() => watchedTasks.current, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctxChanged]);
    return (react_1.default.createElement(TaskWatcherActionsContext_1.default.Provider, { value: actionsCtx },
        react_1.default.createElement(TaskWatcherContext_1.default.Provider, { value: ctx }, children)));
}
exports.TaskWatcherController = TaskWatcherController;
exports.default = TaskWatcherController;
